export const MUSIC_TYPES = [
  { value: 'song', label: 'Song' },
  { value: 'instrumental', label: 'Instrumental' },
  { value: 'piano', label: 'Piano Track' },
  { value: 'minus-one', label: 'Minus 1' },
  { value: 'karaoke', label: 'Karaoke' },
  { value: 'acoustic', label: 'Acoustic' },
  { value: 'cover', label: 'Cover' },
  { value: 'remix', label: 'Remix' },
  { value: 'other', label: 'Other' }
];

export const validateMusicForm = (musicForm, fileUploaded, showToast) => {
  if (!musicForm.name.trim()) {
    showToast('Please enter a music title', 'error');
    return false;
  }
  if (!musicForm.artist.trim()) {
    showToast('Please enter the artist name', 'error');
    return false;
  }
  if (!musicForm.album.trim()) {
    showToast('Please enter the album name', 'error');
    return false;
  }
  if (!musicForm.trackNumber || parseInt(musicForm.trackNumber) <= 0) {
    showToast('Please enter a valid track number', 'error');
    return false;
  }
  if (!fileUploaded || !musicForm.url) {
    showToast('Please upload a music file', 'error');
    return false;
  }
  return true;
};

export const validateVideoForm = (videoForm, showToast) => {
  if (!videoForm.name.trim() || !videoForm.youtubeUrl.trim()) {
    showToast('Please fill in all required fields', 'error');
    return false;
  }
  return true;
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'approved':
      return 'bg-green-100 text-green-800';
    case 'rejected':
      return 'bg-red-100 text-red-800';
    case 'pending':
      return 'bg-yellow-100 text-yellow-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getStatusIcon = (status) => {
  switch (status) {
    case 'approved':
      return '✓';
    case 'rejected':
      return '✕';
    case 'pending':
      return '⏳';
    default:
      return '•';
  }
};